import { Component, Input, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { BookingService } from '@app/listing/services/booking.service';
import ReasonSelectOption from '@app/models/reason-select-option';
import { ArrayService, LogService, NotificationService } from '@app/services';
import { Subscription } from 'rxjs';
import { FormsModule } from '@angular/forms';


@Component({
    selector: "cancel-reason-select",
    templateUrl: "./cancel-reason-select.component.html",
    styleUrls: ["./cancel-reason-select.component.less"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [FormsModule]
})
export class CancelReasonSelectComponent implements OnInit, OnDestroy {
  private readonly _componentName = 'CancelReasonSelectComponent';
  private _selectedReason: ReasonSelectOption;

  /**
   * The full list of reasons that are available.
   */
  public reasons: ReasonSelectOption[];

  /**
   * Dev Comments Subscription
   */
  private showDevComments$: Subscription;

  /**
   * Flag to show developer comments in a comment
   */
  public showDevComments: boolean;

  /**
   * The booking type id for the booking being canceled
   */
  @Input()
  public bookingTypeId: number;

  constructor(
    log: LogService,
    private notify: NotificationService,
    private bookingService: BookingService,
    private arrayHelper: ArrayService
  ) {
    this.showDevComments$ = log.showDevComments.subscribe((x) => (this.showDevComments = x));
  }

  ngOnInit() {
    this.bookingService.getCancelReasons(this.bookingTypeId).subscribe(
      (results) => {
        console.log('workflowService.getReasons=', results);

        this.reasons = this.arrayHelper.orderBy(
          results.map((x) => {
            let option = { ...x, selected: false } as ReasonSelectOption;
            return option;
          }),
          'name'
        );

        const unspecified = this.reasons.find((x) => x.id == 199);
        if (unspecified) {
          unspecified.selected = true;
        }
      },
      (err) => {
        console.error(err);
        
        this.notify.error('An subscription error occured', null);
      }
    );
  }

  /**
   * Called once, before the instance is destroyed.
   */
  ngOnDestroy(): void {
    if (this.showDevComments$) {
      this.showDevComments$.unsubscribe();
    }
  }
  /**
   * Get's the selected reason id
   */
  public get selectedReasonId(): number {
    console.log(`${this._componentName}.selectedReasonId reasons=`, this.reasons);

    if (this.selectedReason) {
      return this.selectedReason.id;
    }

    return null;
  }

  public get selectedReason(): ReasonSelectOption {
    return this._selectedReason;
  }
  public set selectedReason(v: ReasonSelectOption) {
    this._selectedReason = v;
  }

  public onChange(evt: any) {
    console.log(`${this._componentName}.onChange`, evt);

    const reasonId = +evt.target.value;

    this.reasons.forEach((r) => {
      r.selected = r.id === reasonId;
    });
  }
}
